import { Component, Input } from '@angular/core';
import { MRulesItem } from './data-source';
import { EMRulesItemLinkToNext } from './typings';

// 且 | 或
@Component({
  selector: 'm-rules-link',
  template: `
    <p (click)="onClick()">{{ item.linkToNextName }}</p>
  `,
  host: {
    class: 'm-rules-link'
  }
})
export class MRulesLinkComponent {
  @Input() item: MRulesItem = new MRulesItem({});

  onClick(): void {
    if (this.item.linkToNext === EMRulesItemLinkToNext.and) {
      this.item.linkToNext = EMRulesItemLinkToNext.or;
    } else {
      this.item.linkToNext = EMRulesItemLinkToNext.and;
    }
  }
}
